<template>

  <b-modal
      id="modal-history-log-detail"
      ref="modal"
      title="Detalhes da Modificação"
      :size="'lg'"
      :busy="pageListIsLoaded"
      no-close-on-backdrop
      @show="showModal()">

    <template #modal-footer="{ ok }">
      <t-button @click="ok()" class="pr-5 pl-5 ml-3" text="Fechar" primary/>
    </template>

    <b-row>
      <t-input v-model="historyLog.createdDate" datetime label="Data Modificado" cols="6" fixed/>
      <t-input v-model="historyLog.createdUser" label="Responsável" cols="6" fixed/>
    </b-row>

    <b-row>
      <t-input v-model="historyLog.qtyModifications" label="Qtd. Alterações" cols="6" fixed/>
      <t-input v-model="historyLog.version" label="Versão" cols="6" lpad="2" fixed/>
    </b-row>


    <b-table sticky-header class="mt-2" responsive hover :items="list" :fields="fields">

      <template #cell(name)="{item}">
        <b>{{item.name}}</b>
      </template>

      <template #cell(before)="{item}">
        <t-table-field :column="getColumnByVarAndType('Old', item.var,item.type)" :formatter="getFormatterByVarAndType(item.var,item.type)" :item="item"/>
      </template>

      <template #cell(after)="{item}">
        <t-table-field :column="getColumnByVarAndType('Save', item.var,item.type)" :formatter="getFormatterByVarAndType(item.var,item.type)" :item="item"/>
      </template>

    </b-table>


  </b-modal>

</template>
<script>
import {crudGeneral} from "@/services/resource/GeneralCRUD.service";
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin";
import pageListMixin from "@/mixins/page/pageListMixin";
import VarType from "@/model/types/resource/VarType"
import InputType from "@/model/types/resource/InputType"

export default {
  name: "HistoryLogFieldDialog",
  mixins: [pageDefaultMixin, pageListMixin],
  data() {
    return {
      path: "general/history-log",
      list: [],
      fields: [
        {key: "name", label: "Campo", variant:"light"},
        {key: "before", label: "Antes"},
        {key: "after", label: "Depois", variant:"info"},
      ],
    }
  },
  props: {
    pageId: {
      type: Number,
      required: true,
    },
    relationKey: {
      type: Number,
      required: true,
    },
    historyLog: {
      type: Object,
      required: true,
    },
  },
  methods: {

    getColumnByVarAndType(complement, varType, inputType){

      let column = ''

      if (varType === VarType.type.INTEGER || varType === VarType.type.BOOLEAN) {

        if(InputType.isList(inputType)){
          column = 'stringValue' //Exibe o valor convertido na string
        }else{
          column = 'integerValue'
        }

      } else if (varType === VarType.type.DOUBLE) {
        column = 'doubleValue'
      } else if (varType === VarType.type.STRING) {
        column = 'stringValue'
      } else if (varType === VarType.type.DATE) {
        column = 'dateValue'
      }

      return column + complement

    },

    getFormatterByVarAndType(varType, inputType) {

      let formatter = ''

      if (varType === VarType.type.INTEGER || varType === VarType.type.DOUBLE) {

        if(InputType.isList(inputType)){
          formatter = '' //Neste caso deverá usar a string para informar e não o valor numerico
        }else{
          formatter = 'number'
        }

      } else if (varType === VarType.type.BOOLEAN) {
        formatter = 'boolean'
      } else if (varType === VarType.type.STRING) {
        formatter = '' //Não é necessário nenhum formatter
      } else if (varType === VarType.type.DATE) {
        formatter = 'date'
      }

      return formatter

    },


    //Declaro sempre localmente, pois poderá realizar operações diferentes do padrão como setar algum valor padrão vindo de fora e que seria limpo pelo resetModal de forma dinamica
    async showModal() {

      this.pageListIsLoaded = false

      //Setar alguma informações padrão por exemplo vindo de fora

      //DEVERÁ MONTAR OS PARÂMETROS DINAMICAMENTE CONFORME OS CAMPOS FOREM MARCADOS COMO DE PESQUISA
      const path = this.path + "/detail?pageId=" + this.pageId + "&relationKey=" + this.relationKey + "&historyLogId=" + this.historyLog.historyLogId
      await crudGeneral.get(path)
          .then(response => {

            this.list = response.data

            this.pageListIsLoaded = true

          })
          .catch(error => {
            console.log('Erro externo: ' + error)
          })

    },


  }
}
</script>
<style>
</style>
